<template>
  <div v-if="telegramId">
    <div v-if="userData && userData.user" class="home">
      <div class="current-balance">
        <img src="@/assets/Fw3P.gif" class="wallet-icon" alt="">
        {{ userData.current_balance.toFixed(8) }}
      </div>
      <VirtualBalance />
      <ProgressBar />
      <ClaimButton :telegramId="telegramId" :username="username" :reference="ref" :userId="userData.user.id" />

      <div class="box-wrap">
        <span class="rate"><img src="@/assets/1f680.gif" class="wallet-icon"> {{ userData.reward.toFixed(8) }}</span>
        <span class="rate"><img src="@/assets/xt.gif" class="wallet-icon" alt=""> {{ lostReward.toFixed(8) }}</span>
      </div>
    </div>
    <div class="loading" v-else>
      <img src="@/assets/loading.gif" alt="">
    </div>
  </div>


  <div class="no-telegram-id">
    <div class="card text-center">
      <div class="card-body">
        <h5 class="card-title">Telegram App Info</h5>
        <p class="card-text">Join our Telegram app to complete daily tasks and earn coins. Click the button below or scan the QR code with your device to get started.</p>
        <a href="https://t.me/bithermine_bot" class="btn btn-primary">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telegram" viewBox="0 0 16 16">
            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.287 5.906q-1.168.486-4.666 2.01-.567.225-.595.442c-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294q.39.01.868-.32 3.269-2.206 3.374-2.23c.05-.012.12-.026.166.016s.042.12.037.141c-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8 8 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629q.14.092.27.187c.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.4 1.4 0 0 0-.013-.315.34.34 0 0 0-.114-.217.53.53 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09"/>
          </svg> Telegram
        </a>
        <div class="qr-code">
          <canvas id="qrcode"></canvas>
        </div>
      </div>
    </div>
  </div>



</template>

<script>
import { mapGetters } from 'vuex';
import VirtualBalance from '../components/VirtualBalance.vue';
import ProgressBar from '../components/ProgressBar.vue';
import ClaimButton from '../components/ClaimButton.vue';
import QRCode from 'qrcode';

export default {
  name: 'HomeView',
  components: {
    VirtualBalance,
    ProgressBar,
    ClaimButton
  },
  data() {
    return {
      telegramId: '',
      username: '',
      ref: ''
    };
  },
  computed: {
    ...mapGetters(['userData', 'isClaimButtonActive', 'lostReward']),
  },
  methods: {
    getQueryParams() {
      const urlParams = new URLSearchParams(window.location.search);
      this.telegramId = urlParams.get('telegram_id');
      this.username = urlParams.get('username');
      this.ref = urlParams.get('ref') || 'default_ref';
    },
    generateQRCode() {
      const canvas = document.getElementById('qrcode');
      QRCode.toCanvas(canvas, 'https://t.me/bithermine_bot', { width: 200 }, function (error) {
        if (error) console.error(error);
        console.log('QR code generated!');
      });
    }
  },
  created() {
    this.getQueryParams();
    if (this.telegramId) {
      this.$store.dispatch('fetchUserData', {
        telegramId: this.telegramId,
        username: this.username,
        ref: this.ref
      });
    } else {
      this.$nextTick(() => {
        this.generateQRCode();
      });
    }
  }
}
</script>

<style scoped>
.home {
  padding: 20px;
  text-align: center;
  background-color: #000;
  color: #fff;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  background-image: url('@/assets/bg4.webp');
  background-repeat: no-repeat;
  background-size: cover;
}

.current-balance {
  font-size: 1.5rem;
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  font-family: 'Digital-7', sans-serif;
  display: flex;
  align-items: center;
  gap: 10px;
}

.gif {
  position: absolute;
  top: 0px;
  background: transparent;
}

.loading {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.box-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  width: 73.9%;
  margin-left: auto;
  margin-right: auto;
  position: absolute;
  bottom: 80px;
  background: #040C14;
  padding: 8px;
  border-radius: 3px;
}

.rate {
  font-family: 'Digital-7', sans-serif;
}

.wallet-icon {
  width: 24px;
}

.no-telegram-id {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #121212; /* Dark background */
  color: #ffffff; /* White text */
}

.card {
  width: 400px;
  background-color: #1e1e1e; /* Dark card background */
  border: 1px solid #333333; /* Dark border */
  color: #ffffff; /* White text inside card */
}

.card-title {
  color: #ffffff; /* White card title */
}

.card-text {
  color: #cccccc; /* Light grey card text */
}

.btn-primary {
  background-color: #007bff; /* Primary button color */
  border: none;
}

.qr-code {
  margin-top: 50px;
}


</style>
